// components/common/form-date-picker.jsx
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateInput = React.forwardRef(
  ({ value, onClick, placeholder, disabled, isInvalid, className }, ref) => (
    <div style={{ position: "relative" }}>
      <input
        ref={ref}
        value={value || ""}
        onClick={!disabled ? onClick : undefined}
        placeholder={placeholder}
        readOnly
        disabled={disabled}
        className={className}
        style={{ paddingRight: 36 }}
      />
      <i
        className="mdi mdi-calendar-month-outline"
        onClick={!disabled ? onClick : undefined}
        style={{
          position: "absolute",
          right: 10,
          top: "50%",
          transform: "translateY(-50%)",
          cursor: disabled ? "default" : "pointer",
          color: disabled ? "#aaa" : "#6c757d",
          fontSize: 16,
          pointerEvents: disabled ? "none" : "auto",
        }}
      />
    </div>
  )
);

const FormDatePicker = ({
  value,
  onChange,
  isInvalid,
  minDate,
  maxDate,
  disabled,
  disablePast = false,
  placeholderText = "DD/MM/YYYY",
  className = "",
  filterDate,
}) => {
  const today = disablePast ? new Date(new Date().setHours(0, 0, 0, 0)) : undefined;
  const resolvedMinDate = minDate ?? today;

  const inputClassName =
    "form-control" +
    (isInvalid ? " is-invalid" : "") +
    (className ? ` ${className}` : "");

  return (
    <DatePicker
      selected={value ?? null}
      onChange={onChange}
      dateFormat="dd/MM/yyyy"
      placeholderText={placeholderText}
      calendarClassName="custom-calendar"
      dayClassName={() => "custom-day"}
      showPopperArrow={false}
      minDate={resolvedMinDate}
      maxDate={maxDate}
      disabled={disabled}
      filterDate={filterDate}
      customInput={
        <DateInput
          disabled={disabled}
          isInvalid={isInvalid}
          className={inputClassName}
        />
      }
    />
  );
};

export default FormDatePicker;